export namespace ExportXmlActions {
    export class OpenModal {
        static readonly type = 'ExportXml.OpenModal';
    }

    export class Export {
        static readonly type = 'ExportXml.Submit';
    }
}
